import { render, staticRenderFns } from "./kyb.vue?vue&type=template&id=1e6e6efa"
import script from "./kyb.vue?vue&type=script&lang=js"
export * from "./kyb.vue?vue&type=script&lang=js"
import style0 from "./kyb.vue?vue&type=style&index=0&id=1e6e6efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports